import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import { useReactToPrint } from 'react-to-print';
import { Button, /* Checkbox, FormControlLabel,  */Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { CboProfesionales } from '../../cbos/CboProfesionales';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { agendaLimpiar, cancelarTurno, confirmarAsistenciaTurno, confirmarBajaTurnos, exportExcelPorProfesional, fetchTurnosTomadosHastaFecha, generatePdfPorProfesional } from '../../../actions/turnos/agenda';
import { AlertFinalizadoStepper } from '../../stepper/AlertFinalizadoStepper';
import { fetchMotivosBajaTurno } from '../../../actions/turnos/motivosBajaTurno';
import { efectorHorariosLimpiar } from '../../../actions/turnos/efectorHorarios';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { TURNOS_PERMISOS } from '../../../utils/permisos';
import { TableToolbarExportAndPrint } from '../recepcionDiaria/TableToolbarExportAndPrint';
import { HorariosLicenciasProfesional } from '../recepcionDiaria/HorariosLicenciasProfesional';
import { licenciasProfesionalesLimpiar } from '../../../actions/turnos/licenciasProfesionales';

const useStyles = makeStyles({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
        // width: "100%",
    },
    input: {
        padding: 10,
    }
});

const stateInitial = {
    idProfesional: null,
    maxDate: new Date(),
};

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const transformDay = (day) => {
    switch (day) {
        case 0:
            return "Domingo"
        case 1:
            return "Lunes"
        case 2:
            return "Martes"
        case 3:
            return "Miércoles"
        case 4:
            return "Jueves"
        case 5:
            return "Viernes"
        case 6:
            return "Sábado"
        default:
            return null
    }
}

export const ConsultaProfesional = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items, cargada } = useSelector((state) => state.agenda);
    const { items: motivosBajaItems, cargada: motivosBajaCargados } = useSelector((state) => state.motivosBajaTurno);
    const { permisos: permisosUser } = useSelector(state => state.auth)

    const [formValues, handleInputChange, , setearValor] = useForm(stateInitial);
    const { idProfesional, maxDate } = formValues;

    const [openCancelar, setOpenCancelar] = useState(false);
    const [openConfirmar, setOpenConfirmar] = useState(false);
    const [confirmado, setConfirmado] = useState(false);
    const [turnoSelec, setTurnoSelec] = useState();
    const [idMotivoCancelacion, setIdMotivoCancelacion] = useState();

    const permisoAdmin = validarSoloUnPermiso(
        permisosUser,
        TURNOS_PERMISOS.PERMITE_CANCELAR_ASISTENCIA_SIN_MIRAR_FECHA
    )


    useEffect(() => {
        if (!motivosBajaCargados) {
            dispatch(fetchMotivosBajaTurno());
        }
    }, [dispatch, motivosBajaCargados]);

    useEffect(() => {
        dispatch(efectorHorariosLimpiar());
        dispatch(licenciasProfesionalesLimpiar());
    }, [dispatch]);

    useEffect(() => {
        if (idProfesional && maxDate) {
            dispatch(fetchTurnosTomadosHastaFecha(maxDate.toISOString(), idProfesional));
        } else {
            dispatch(agendaLimpiar());
            dispatch(efectorHorariosLimpiar());
            dispatch(licenciasProfesionalesLimpiar());
        }
    }, [dispatch, idProfesional, maxDate]);

    const handleOpenCancelarTurno = turno => {
        setTurnoSelec(turno);
        setOpenCancelar(true);
    }

    const handleSendCancelarTurno = () => {
        if (turnoSelec.sobreTurno)
            dispatch(confirmarBajaTurnos([turnoSelec.idAgenda], idMotivoCancelacion));
        else
            dispatch(cancelarTurno(turnoSelec.idAgenda, idMotivoCancelacion));
        resetValues();
        setOpenCancelar(false);
    }

    /* const handleOpenConfirmarAsistencia = (turno, checked) => {
      setTurnoSelec(turno);
      setConfirmado(checked);
      setOpenConfirmar(true);
    } */

    const handleSendConfirmarAsistencia = () => {
        dispatch(confirmarAsistenciaTurno(turnoSelec.idAgenda, confirmado));
        resetValues();
        setOpenConfirmar(false);
    }

    const handleCloseAlert = () => {
        resetValues();
        setOpenCancelar(false);
        setOpenConfirmar(false);
    }

    const handleInputChangeMotivo = ({ target }) => {
        setIdMotivoCancelacion(target.value);
    }

    const resetValues = () => {
        setTurnoSelec();
        setConfirmado(false);
        setIdMotivoCancelacion();
    }

    const componentRef = React.useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const handleGeneratePdf = () => {
        // TODO add filters
        dispatch(generatePdfPorProfesional(maxDate.toISOString(), idProfesional));
    }

    const handleExportExcel = () => {
        // TODO add filters
        dispatch(exportExcelPorProfesional(maxDate.toISOString(), idProfesional, moment().format("YYYY-MM-DD")));
    }

    return (
        <Grid container className={classes.root} justify="center" spacing={1}>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                    <Grid item xs={12} md={5}>
                        <Paper className={classes.input}>
                            <CboProfesionales
                                manejadorInputChange={handleInputChange}
                                filtrarPorUsuario={true}
                                conEspecialidad={true}
                                valor={idProfesional}
                                autocomplete={true}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={5}>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Paper className={classes.input} >
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Hasta"
                                    format="dd/MM/yyyy"
                                    required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    minDate={new Date()}
                                    value={
                                        moment(maxDate).isValid()
                                            ? moment(maxDate)
                                            : 0
                                    }
                                    onChange={(date) => {
                                        setearValor("maxDate", date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Paper>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                    <HorariosLicenciasProfesional
                        title={'Horarios / Licencias'}
                        idProfesional={idProfesional}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <TableContainer component={Paper}>
                    <Table ref={componentRef}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Afiliado</TableCell>
                                <TableCell align="left">N° Afiliado</TableCell>
                                <TableCell align="left">Fecha</TableCell>
                                <TableCell align="left">Día</TableCell>
                                <TableCell align="left">Hora</TableCell>
                                <TableCell align="left">Sobre Turno</TableCell>
                                <TableCell align="left">Centro Médico</TableCell>
                                <TableCell align="left">Profesional</TableCell>
                                <TableCell align="left">Especialidad</TableCell>
                                <TableCell align="left">Modalidad</TableCell>
                                {permisoAdmin &&
                                    <TableCell align="left">Otorgado por</TableCell>
                                }
                                {/* <TableCell align="left">Asiste</TableCell> */}
                                <TableCell align="left"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {items.length > 0
                                ?
                                items.map((item) => (
                                    <TableRow key={item.idAgenda}>
                                        <TableCell align="left">
                                            {item.afiliado || item.afiliadoExterno
                                                ?
                                                `${item.afiliado?.apellido_y_nombre || item.afiliadoExterno?.apellidoNombre} / Tel: ${item.afiliado?.domiciliosAfiliados?.celular || item.afiliadoExterno?.domiciliosAfiliados?.celular} / ${item.afiliado?.domiciliosAfiliados?.telefono || item.afiliadoExterno?.domiciliosAfiliados?.telefono}`
                                                :
                                                `Libre`
                                            }
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.afiliado?.carnet || item.afiliadoExterno?.carnet}
                                        </TableCell>
                                        <TableCell align="left">
                                            {new Date(item.fecha).toLocaleString(
                                                "es",
                                                optionsfecha
                                            )}
                                        </TableCell><TableCell align="left">
                                            {transformDay(moment(item.fecha).day())}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.hora}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.sobreTurno ? 'Si' : 'No'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.centroMedico?.descripcionCentro}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.efectorRed?.nombreEfector}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.especialidad?.descripcionEspecialidades}
                                        </TableCell>
                                        <TableCell align="left">
                                            {item.afiliado || item.afiliadoExterno ? (item.idTipoTurnoSol === 1 ? 'Presencial' : 'Virtual')
                                                : (item.idTipoTurno === 1 ? "Presencial" : (item.idTipoTurno === 2 ? "Virtual" : "Ambos"))}
                                        </TableCell>
                                        {permisoAdmin &&
                                            <TableCell align="left">
                                                {item?.usuario?.userName
                                                    ? item?.usuario?.userName
                                                    : "Afiliado"}
                                            </TableCell>
                                        }
                                        {/* <TableCell >
                                            <FormControlLabel style={{marginLeft: 2, marginRight: 0}}
                                                control={
                                                <Checkbox
                                                    name="presencial"
                                                    checked={item.confirmado}
                                                    disabled={!moment(maxDate).isSame(moment(), 'day') || !validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.ASISTENCIA)}
                                                    onChange={(e) => handleOpenConfirmarAsistencia(item, e.target.checked)}
                                                />
                                                }
                                            />
                                        </TableCell> */}
                                        <TableCell align="left" style={{ padding: 12 }}>
                                            <Button
                                                style={{ marginLeft: -2 }}
                                                variant="contained"
                                                onClick={() => handleOpenCancelarTurno(item)}
                                                disabled={item.confirmado || moment(maxDate).isBefore(moment(), 'day') || (!item.afiliado && !item.afiliadoExterno) || !validarSoloUnPermiso(permisosUser, TURNOS_PERMISOS.CANCELAR)}
                                                color="primary"
                                            >
                                                Cancelar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                                :
                                <TableRow style={{ height: 50 }}>
                                    <TableCell colSpan={10} style={{ textAlign: '-webkit-center' }}> Sin Registros</TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item xs={11}>
                <Grid item container>
                    <Grid item xs={4}></Grid>
                    <Grid item xs={4}>
                        {cargada &&
                            <TableToolbarExportAndPrint
                                cargada={cargada}
                                handlePrint={handlePrint}
                                handleGeneratePdf={handleGeneratePdf}
                                handleExportExcel={handleExportExcel}
                            />
                        }
                    </Grid>
                    <Grid item xs={4}></Grid>
                </Grid>
            </Grid>
            {openCancelar &&
                <AlertFinalizadoStepper
                    open={openCancelar}
                    pregunta={'Cancelación de Turno'}
                    dialogText={`Quiere proceder con la Cancelación del Turno de ${turnoSelec?.afiliado?.apellido_y_nombre}?`}
                    buttonCancel={"Cancelar"}
                    buttonSubmit={"Continuar"}
                    showComboDialog={true}
                    itemsCombo={motivosBajaItems}
                    labelCombo={'Motivo'}
                    idCombo={'idMotivoBajaTurno'}
                    manejadorInputChange={handleInputChangeMotivo}
                    valor={idMotivoCancelacion}
                    handleClose={handleCloseAlert}
                    handleSend={handleSendCancelarTurno}
                />
            }
            {openConfirmar &&
                <AlertFinalizadoStepper
                    open={openConfirmar}
                    pregunta={`${confirmado ? 'Confirmar' : 'Anular'} Asistencia al Turno`}
                    dialogText={`Quiere proceder con la ${confirmado ? 'Confirmación' : 'Anulación'} de Asistencia al turno de ${turnoSelec?.afiliado?.apellido_y_nombre}?`}
                    buttonCancel={"Cancelar"}
                    buttonSubmit={"Confirmar"}
                    handleClose={handleCloseAlert}
                    handleSend={handleSendConfirmarAsistencia}
                />
            }
        </Grid>
    );

};
